// Waiting page (/password): film slideshow and the password dialog.
// The two forms are plain Shopify forms and need no script.
(() => {
  const root = document.querySelector('[data-tdw]');
  if (!root) return;

  // ---------- Password dialog ----------

  const dialog = root.querySelector('[data-tdw-dialog]');
  root.querySelector('[data-tdw-dialog-open]').addEventListener('click', () => dialog.showModal());
  root.querySelector('[data-tdw-dialog-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  // A wrong password reloads the page: put the visitor back where they were.
  if (dialog.querySelector('[data-tdw-password-error]')) dialog.showModal();

  // ---------- Slideshow ----------
  // One film at a time. Each stays for the section's interval, then the next
  // fades in. A film is only fetched when its turn is near.

  const slidesEl = root.querySelector('[data-tdw-slides]');
  const slides = [...slidesEl.querySelectorAll('[data-tdw-slide]')].map((el) => ({
    el,
    video: el.querySelector('video'),
    src: el.dataset.src,
    ratio: Number(el.dataset.ratio),
  }));
  if (!slides.length) return;

  const slideMs = Number(slidesEl.dataset.seconds || 10) * 1000;
  const countEl = root.querySelector('[data-tdw-count]');
  const dotsEl = root.querySelector('[data-tdw-dots]');
  const autoButton = root.querySelector('[data-tdw-auto]');
  const autoLabel = autoButton.querySelector('span');

  // Visitors who ask for reduced motion get still frames until they press Play.
  let motion = !matchMedia('(prefers-reduced-motion: reduce)').matches;
  let auto = motion;
  let current = -1;
  let elapsed = 0;
  let lastTick = performance.now();

  slides.forEach((slide, i) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'tdw-show-dot';
    dot.setAttribute('aria-label', `${dotsEl.dataset.label} ${i + 1} / ${slides.length}`);
    dot.innerHTML = '<i><b></b></i>';
    dot.addEventListener('click', () => show(i));
    dotsEl.append(dot);
    slide.dot = dot;
  });

  // A film much squarer than the space would lose its top and bottom if it
  // filled the space, so it is shown whole over a blurred still of itself.
  function fitSlides() {
    const space = slidesEl.clientWidth / slidesEl.clientHeight;
    for (const slide of slides) {
      slide.el.classList.toggle('tdw-slide--whole', space / slide.ratio > 1.6);
    }
  }
  new ResizeObserver(fitSlides).observe(slidesEl);

  function load(slide) {
    if (!slide.video.getAttribute('src')) slide.video.src = slide.src;
  }

  function show(index) {
    const next = (index + slides.length) % slides.length;
    if (next === current) return;
    const previous = slides[current];
    const slide = slides[next];
    current = next;
    elapsed = 0;
    countEl.textContent = `${next + 1} / ${slides.length}`;
    if (motion) {
      load(slide);
      slide.video.currentTime = 0;
      slide.video.play().catch(() => {});
    }
    for (const other of slides) {
      other.el.classList.toggle('is-active', other === slide);
      other.dot.setAttribute('aria-current', String(other === slide));
      other.dot.style.setProperty('--progress', 0);
    }
    if (previous) setTimeout(() => { if (slides[current] !== previous) previous.video.pause(); }, 900);
    // Have the following film ready before its turn.
    if (motion) setTimeout(() => load(slides[(next + 1) % slides.length]), 2500);
  }

  function setAuto(on) {
    auto = on;
    autoButton.setAttribute('aria-pressed', String(on));
    autoLabel.textContent = on ? autoButton.dataset.pause : autoButton.dataset.play;
    if (on && !motion) {
      motion = true;
      load(slides[current]);
      slides[current].video.play().catch(() => {});
    }
  }

  autoButton.addEventListener('click', () => setAuto(!auto));
  root.querySelector('[data-tdw-prev]').addEventListener('click', () => show(current - 1));
  root.querySelector('[data-tdw-next]').addEventListener('click', () => show(current + 1));

  // Swipe left or right on the film to change it.
  let swipeX = null;
  slidesEl.addEventListener('pointerdown', (event) => { swipeX = event.clientX; });
  slidesEl.addEventListener('pointerup', (event) => {
    if (swipeX === null) return;
    const moved = event.clientX - swipeX;
    swipeX = null;
    if (Math.abs(moved) > 48) show(current + (moved < 0 ? 1 : -1));
  });

  setInterval(() => {
    const now = performance.now();
    const step = now - lastTick;
    lastTick = now;
    if (!auto || document.hidden || dialog.open) return;
    elapsed += Math.min(step, 500);
    slides[current].dot.style.setProperty('--progress', Math.min(elapsed / slideMs, 1));
    if (elapsed >= slideMs) show(current + 1);
  }, 100);

  show(0);
  setAuto(auto);
})();
